import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import cx from 'classnames'
import { format } from 'date-fns'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { FormErrorMessage } from '@f/elements/HookForm/ErrorMessage'

interface FormDatePickerProps
  extends Omit<DatePickerProps<string>, 'onChange' | 'value'> {
  name: string
  className?: string
  dateFormat?: string
  returnDateFormat?: string
}

const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy'
const RETURN_DATE_FORMAT = 'yyyy-MM-dd'

export const FormDatePicker = ({
  name,
  className,
  dateFormat = DISPLAY_DATE_FORMAT,
  returnDateFormat = RETURN_DATE_FORMAT,
  ...rest
}: FormDatePickerProps) => {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field: { ref, ...fieldProps }, fieldState }) => {
        return (
          <>
            <div className={cx('FormDatePicker', className)}>
              <DatePicker
                desktopModeMediaQuery='(min-width: 1200px)'
                closeOnSelect
                format={dateFormat}
                label='Datum'
                {...fieldProps}
                {...rest}
                value={fieldProps.value && new Date(fieldProps.value)}
                onChange={value => {
                  if (value && !isNaN(value.getTime?.())) {
                    fieldProps.onChange(
                      format(new Date(value), returnDateFormat)
                    )
                  }
                }}
                inputRef={ref}
              />
            </div>
            {fieldState.error && (
              <FormErrorMessage>{fieldState.error.message}</FormErrorMessage>
            )}
          </>
        )
      }}
    />
  )
}
